// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import 'lib-flexible'
import store from "./store/store"
import axios from 'axios'
import Cookies from 'js-cookie'
axios.defaults.headers.post["Content-type"]="application/json";
Vue.prototype.$axios = axios
Vue.prototype.Cookies = Cookies

Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.noScroll = function () {
  var mo = function (e) { e.preventDefault() }
  document.body.style.overflow = 'hidden'
  document.addEventListener('touchmove', mo, false)// 禁止页面滑动
}
 
//弹出框可以滑动
Vue.prototype.canScroll = function () {
  var mo = function (e) {
    e.preventDefault()
  }
  document.body.style.overflow = ''// 出现滚动条
  document.removeEventListener('touchmove', mo, false)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js